module.exports = __webpack_public_path__ + "static/calmisland-077e2cf0276d4547c959e89d68826eac.png";